import { getInputEvent } from '@/helpers/device';
import { CommonConstants } from '@/config/constant';

export default {
  mounted(el) {
    const inputEvent = getInputEvent();
    el.addEventListener(
      inputEvent,
      (e) => {
        e.target.value = e.target.value.replace(CommonConstants.NUMBER_VALIDATION_REGEX, '');
      },
      true
    );
  },
};
